import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import AccessoryTable from "./AccessoryTable";
import AccessoryFormModal from "./AccessoryFormModal";
import api from "../../../services/api";
import { useAppConfig } from "../../../context/AppConfigContext";

const AccessoryAdminPage = () => {
  const [accessories, setAccessories] = useState([]);
  const [selectedAccessory, setSelectedAccessory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { config } = useAppConfig();
  const subcategories = config?.accessories?.subcategories || [];

  const fetchAccessories = async () => {
    try {
      const res = await api.get("/accessories");
      setAccessories(res.data);
    } catch (err) {
      console.error("Failed to fetch accessories", err);
    }
  };

  useEffect(() => {
    fetchAccessories();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/accessories/${id}`);
      fetchAccessories();
    } catch (err) {
      console.error("Failed to delete accessory", err);
    }
  };

  return (
    <Box sx={{ px: 3, py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Manage Accessories
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
        onClick={() => {
          setSelectedAccessory(null);
          setIsModalOpen(true);
        }}>
        Add New Accessory
      </Button>

      <AccessoryTable
        data={accessories}
        onEdit={(item) => {
          setSelectedAccessory(item);
          setIsModalOpen(true);
        }}
        onDelete={handleDelete}
      />

      {isModalOpen && (
        <AccessoryFormModal
          open={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedAccessory(null);
          }}
          onSave={fetchAccessories}
          accessory={selectedAccessory}
          subcategories={subcategories}
        />
      )}
    </Box>
  );
};

export default AccessoryAdminPage;
